module.exports = __webpack_public_path__ + "img/1.845b2c53.png";